import { GradientDivider } from '@ethena/shared-ui/src/components/GradientDivider'
import { cn } from '@ethena/shared-ui/utils'

export const SectionHeader = ({
  description,
  showDivider = true,
  title,
  titleClassName,
}: {
  title: React.ReactNode
  description?: React.ReactNode
  titleClassName?: string
  showDivider?: boolean
}) => {
  return (
    <>
      <h2
        className={cn(
          'text-center text-[36px] sm:text-[48px] font-medium leading-[56px] gradient-text mb-6 hmd:mb-8',
          titleClassName,
        )}
      >
        {title}
      </h2>
      {description && (
        <p className="text-center text-text-secondary text-lg mb-[24px] hsmmd:mb-[60px] font-inter">{description}</p>
      )}

      {showDivider && (
        <GradientDivider
          variant="horizontal"
          width="w-full max-w-[300px]"
          className="mb-[24px] hbase:mb-[40px] hxl:mb-[42px] mx-auto"
        />
      )}
    </>
  )
}
